const pdm_list = require('./pdms.json')
const op_zones_list = require('./op_zones.json')
const support_list = require('./support.json')

const PDMS = pdm_list
	.map(pdm => {
		return {
			text: pdm.name,
			value: pdm.linux_path, // Format Maestro (interne)
			unc_path: pdm.unc_path.replace('.cmc.fr', '').replace(/\\/g, '/'), // Format UNC (affichage)
			category: pdm.category
		}
	})

const OP_ZONES = op_zones_list
	.filter(opZone => {
		return /^[a-zA-Z]{2}_.+$/.test(opZone[0])
	})
	.map(opZone => {
		return {
			text: opZone[1],
			value: opZone[0]
		}
	})

const PDMS_LINUX = PDMS.reduce((obj, item) => {
	obj[item['value']] = { ...item }
	return obj
}, {})

const PDMS_WIN = PDMS.reduce((obj, item) => {
	obj[item['unc_path']] = { ...item }
	return obj
}, {})

const PROJECTS = support_list.projects
	.map(project => {
		return {
			text: project[1],
			value: project[0]
		}
	})
	.sort((a, b) => a.text.localeCompare(b.text))

const CATEGORIES = support_list.categories
	.map(category => {
		return {
			text: category[1],
			value: category[0]
		}
	})
	.sort((a, b) => a.text.localeCompare(b.text))

export {
	PDMS,
	OP_ZONES,
	PDMS_LINUX,
	PDMS_WIN,
	PROJECTS,
	CATEGORIES
}



// WEBPACK FOOTER //
// ./src/constants.js